import { createSlice } from '@reduxjs/toolkit';

export const catalogMenu = createSlice({
  name: 'catalogMenu',

  initialState: {
    exists: false,
    visible: false,
    subMenu: null,
  },

  reducers: {
    start: (state) => {
      state.exists = true;
      return state;
    },

    show: (state) => {
      state.visible = true;
      return state;
    },

    hide: (state) => {
      state.visible = false;
      return state;
    },

    toggle: (state) => {
      const newVisible = !state.visible;
      state.visible = newVisible;
      return state;
    },

    enableSubMenu: (state, { payload: idx }) => {
      state.subMenu = idx;
      return state;
    },

    resetSubMenu: (state) => {
      state.subMenu = null;
      return state;
    },
  },
});

export default catalogMenu.reducer;
